import { UnlockButton } from 'blaze-components/WriterTopBar/UnlockButton'
import { Text } from 'blaze-ui/Text/Text'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { useHeaderTheme } from 'hooks/useHeaderTheme'

export const TemplatesMobileTopBar = ({ title }: { title: string }) => {
  const theme = useHeaderTheme()
  return (
    <MobileTopBarContainer.Root data-theme={theme}>
      <MobileTopBarContainer.Left>
        <UnlockButton />
      </MobileTopBarContainer.Left>
      <MobileTopBarContainer.Center>
        <Text>{title}</Text>
      </MobileTopBarContainer.Center>
      <MobileTopBarContainer.Right>
        <div id="search-templates" />
      </MobileTopBarContainer.Right>
    </MobileTopBarContainer.Root>
  )
}
